import React, { ComponentProps } from "react";

function PersonDuoIcon(props: ComponentProps<"svg">) {
  return (
    <svg
      width={20}
      height={13}
      viewBox="0 0 20 13"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g id="person.2.fill">
        <g id="Group">
          <path
            id="Vector"
            d="M10.6526 12.9959H2.30461C1.20078 12.9959 0.818494 12.6632 0.818494 12.0474C0.818494 10.3245 3.00438 7.95511 6.47861 7.95511C9.94735 7.95511 12.1332 10.3245 12.1332 12.0474C12.1332 12.6632 11.751 12.9959 10.6526 12.9959ZM6.47312 6.76608C5.01478 6.76608 3.77712 5.4683 3.77712 3.79058C3.77712 2.14379 5.02267 0.890625 6.47312 0.890625C7.92906 0.890625 9.18129 2.16696 9.17461 3.80277C9.17221 5.4683 7.93695 6.76608 6.47312 6.76608Z"
          />
          <path
            id="Vector_2"
            d="M17.9077 12.9978H12.8889C13.6023 11.9733 12.8181 9.94607 11.3102 8.76819C12.0493 8.2919 13.0081 7.93687 14.2163 7.93687C17.2087 7.93687 19.1429 10.1451 19.1429 11.965C19.1429 12.6232 18.8099 12.9978 17.9077 12.9978ZM14.2163 6.91956C12.9424 6.91956 11.8655 5.78371 11.8655 4.32818C11.8655 2.89447 12.9503 1.80322 14.2163 1.80322C15.4756 1.80322 16.5727 2.91643 16.566 4.33916C16.5648 5.78371 15.4848 6.91956 14.2163 6.91956Z"
            fillOpacity="0.5"
          />
        </g>
      </g>
    </svg>
  );
}

export default PersonDuoIcon;
